export default __webpack_public_path__ + "static/media/nex-ten-bg.9011290f.png";